import { useEffect, useState } from 'react';
import DatePicker from 'react-multi-date-picker';

function Group(props) {
	const { className, style, children } = props;
	return (
		<div className={className ? `gs-input-group ${className}` : 'gs-input-group'} style={style}>
			{children}
		</div>
	);
}

function Input(props) {
	const {
		id,
		name='',
		type,
		className,
		style,
		label,
		showLabel,
		placeholder,
		value,
		essential,
		readOnly,
		disabled,
		autoComplete,
		autoFocus,
		maxLength,
		onChange,
		onKeyDown,
		children,
	} = props;

	return (
		<div className={className ? `gs-input ${className}` : 'gs-input'} style={style}>
			{label && (
				<label
					id={label ? `${id}-label` : null}
					htmlFor={id}
					className={`${essential ? 'gs-essential' : ''} ${showLabel ? '' : 'sr-only'}`}
				>
					{label}
				</label>
			)}
			<input
				type={type ? type : 'text'}
				id={id}
				name={name}
				placeholder={placeholder}
				aria-labelledby={label ? `${id}-label` : null}
				value={value}
				readOnly={readOnly}
				disabled={disabled}
				autoComplete={autoComplete ? 'on' : 'off'}
				autoFocus={autoFocus}
				maxLength={maxLength}
				onKeyDown={onKeyDown}
				onChange={onChange}
			/>
			{children}
		</div>
	);
}

function PasswordEye(props) {
	const { id, label, placeholder, children, ...rest } = props;
	const [eye, setEye] = useState(false);

	return (
		<Input
			id={id}
			type={eye ? 'text' : 'password'}
			label={label}
			placeholder={placeholder}
			maxLength={20}
			{...rest}
		>
			<button
				type="button"
				className={`icon-btn-eye${eye ? ' on' : ''}`}
				title={`비밀번호 ${eye ? '숨기기' : '표시'}`}
				onClick={() => setEye(prev => !prev)}
			>
				<span className="sr-only">{`비밀번호 ${eye ? '숨기기' : '표시'}`}</span>
			</button>
			{children}
		</Input>
	);
}

function Datepicker(props) {
	const { startDate, setStartDate, endDate, setEndDate, children } = props;

	return (
        <div className="gs-input">
			{children}
			<div className="flex-item">
				<DatePicker
					id="startDate"
					selected={startDate}
					dateFormat="yyyy.MM.dd"
					value={startDate}
					onChange={(date) => setStartDate(date)}
					autoComplete="off"
				/>
				&nbsp; ~ &nbsp;
				<DatePicker
					id="endDate"
					selected={endDate}
					dateFormat="yyyy.MM.dd"
					value={endDate}
					onChange={(date) => setEndDate(date)}
					autoComplete="off"
				/>
			</div>
        </div>
	)
}

Input.Group = Group;
Input.PasswordEye = PasswordEye;
Input.DatePicker = Datepicker;

export default Input;

export const onEnter = (e, func = () => {}) => {
	if(e.key === "Enter" || e.keyCode === 13) {
		func();
	}
}
